<template>
  <div class="icon">
    <img
      v-if="i18n.locale === 'en'"
      class="icon-item"
      src="../../../../assets/pl512.png"
      alt="Polish"
      @click="() => updateConfig('pl')"
    />
    <img
      v-if="i18n.locale === 'pl'"
      class="icon-item"
      src="../../../../assets/uk512.png"
      alt="English"
      @click="() => updateConfig('en')"
    />
  </div>
</template>

<script>
import i18n from "../../../../i18n";
import axios3C from "./../../../../axios";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Locale",
  data: function() {
    return {
      i18n
    };
  },
  computed: {
    ...mapState(["cart_id"])
  },
  methods: {
    ...mapMutations(["setLang", "setCurrency"]),
    updateConfig: async function(country) {
      if (country === "pl") {
        this.setLang("pl");
        if (this.cart_id) {
          await axios3C.post("/cart", {
            action: "updateCart",
            cart_id: this.cart_id,
            field: "currency",
            value: "pln",
            customer: "guest"
          });
        }
        this.setCurrency("pln");
      } else if (country === "en") {
        this.setLang("en");
        if (this.cart_id) {
          await axios3C.post("/cart", {
            action: "updateCart",
            cart_id: this.cart_id,
            field: "currency",
            value: "eur",
            customer: "guest"
          });
        }
        this.setCurrency("eur");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  z-index: 200;
  margin-left: 15px;
}

.icon-item {
  width: 30px;
  z-index: 200;

  &:hover {
    cursor: pointer;
  }
}
</style>
